import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import ContextualMenu from '../../components/ContextualMenu';
import AppConfig from '../../config';
import { t } from '../../lang';
import { authSlice } from '../../store/slices';
import bg from './Welcome.png';

import './WelcomePage.scss';

const { routes, name } = AppConfig;

const WelcomePage = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		dispatch(authSlice.actions.resetState());
	}, []);

	// HelperService.showNotification({
	// 	type: 'default',
	// 	icon: 'CHECKMARK_CIRCLE_FILL',
	// 	title: t('Address copied'),
	// 	descriptin: 'descriptin',
	// 	autoHideDuration: 1000000,
	// 	// visibleClose: true,
	// 	// firstBtnText: 'firstBtnText',
	// 	// secondBtnText: 'secondBtnText',
	// });

	// HelperService.showNotification({
	// 	icon: 'DOCUMENTS_ICON_PURPLE',
	// 	title: t('Address copied'),
	// 	descriptin: t('Address copied'),
	// 	autoHideDuration: 1000000,
	// 	iconSize: 32,
	// });

	// const closeComponent = () => <AdaptiveButton icon='CHECKMARK_CIRCLE_FILL'>Children</AdaptiveButton>;
	const closeComponent = () => <ContextualMenu icon='CHECKMARK_CIRCLE_FILL'>Children</ContextualMenu>;

	const firstItem = () => <div>div</div>;

	const itemsMenu = [
		{
			icon: 'CHECKMARK_CIRCLE_FILL',
			content: firstItem,
			onClick: () => console.log('1111111'),
			separator: false,
		},
		{
			icon: 'PLUS_CIRCLE_FILL',
			content: 'content2',
			onClick: () => console.log('11122222221111'),
			separator: true,
		},
		{
			icon: 'PLUS_CIRCLE_FILL',
			content: 'content23',
			onClick: setExpand => {
				console.log('11122222221111');
				setExpand(false);
			},
			separator: false,
		},
	];

	const openComponent = ({ expand, setExpand }) => {
		return (
			<div className='openComponent'>
				{itemsMenu.map((i, index) => (
					<ContextualMenu
						key={index}
						icon={i.icon}
						content={i.content}
						onClick={() => i.onClick(setExpand)}
						separator={i.separator}
					/>
				))}
			</div>
		);
	};

	const DropdownContent = open => (
		<>
			jhdsnfjhsbdhfbsjhdf jhdsnfjhsbdhfbsjhdf jhdsnfjhsbdhfbsjhdf jhdsnfjhsbdhfbsjhdf jhdsnfjhsbdhfbsjhdf
			jhdsnfjhsbdhfbsjhdf jhdsnfjhsbdhfbsjhdf jhdsnfjhsbdhfbsjhdfjhdsnfjhsbdhfbsjhdfjhdsnfjhsbdhfbsjhdf
			jhdsnfjhsbdhfbsjhdfjhdsnfjhsbdhfbsjhdf jhdsnfjhsbdhfbsjhdf jhdsnfjhsbdhfbsjhdf
		</>
	);

	const triggerProps = {
		description: 'test description',
		trailing: <>trailing WelcomePage trailing WelcomePage</>,
	};

	const num = '1234567890909926';

	return (
		<div className='WelcomePage'>
			<img className='WelcomePage-bg' src={bg} alt='' />

			{/* {HelperService.showAllIcons()} */}

			{/* <Dropdown triggerTitle='More details' triggerProps={triggerProps} content={DropdownContent} /> */}

			{/* <Card color='black' paymentSystem='mastercard' />
			<Card color='black' paymentSystem='mastercard' />
			<Card color='black' number={num} cardholderName='Alexandr Wike' paymentSystem='mastercard' status='frozen' />
			<Card status='empty' /> */}
			{/* <Card
				color='black'
				number={num}
				cardholderName='Alexandr Wike'
				paymentSystem='mastercard'
				copyNumberByLongPress
				flipCardByPress
			/> */}
			{/* <Card color='purple' number={num} cardholderName='Alexandr Wike' paymentSystem='mastercard' />
			<Card color='green' number={num} cardholderName='Alexandr Wike' paymentSystem='mastercard' />
			<Card color='black' number={num} cardholderName='Alexandr Wike' paymentSystem='visa' />
			<Card color='white' number={num} cardholderName='Alexandr Wike' paymentSystem='visa' />
			<Card color='black' paymentSystem='mastercard' />
			<Card color='white' paymentSystem='mastercard' />
			<Card color='black' number={num} cardholderName='Alexandr Wike' paymentSystem='mastercard' status='frozen' /> */}
			{/* <Card
				color='white'
				number={num}
				cardholderName='Alexandr Wike'
				paymentSystem='mastercard'
				status='frozen'
				coverButtonHandler={() => console.log('Unfrrr')}
			/> */}
			{/* <Card color='black' number={num} cardholderName='Alexandr Wike' paymentSystem='mastercard' status='closed' /> */}
			{/* <Card color='white' number={num} cardholderName='Alexandr Wike' paymentSystem='mastercard' status='closed' />
			<Card color='black' number={num} cardholderName='Alexandr Wike' paymentSystem='mastercard' status='closing' /> */}
			{/* <Card color='white' number={num} cardholderName='Alexandr Wike' paymentSystem='mastercard' status='closing' />
			<Card className='WalletPayCard-grey' paymentSystem='mastercard' />
			<Card
				className='WalletPayCard-blue'
				paymentSystem='mastercard'
				contentElement={<div>ЕСЛИ НАДО ПИХНУТЬ КАКОЙ-ТО КАСТОМНЫЙ КОНТЕНТ - ЭТО ВОТ СЮДА</div>}
			/> */}

			<div className='WelcomePage-content'>
				<div className='WelcomePage-content-wrapper'>
					<div className='title'>{t('Welcome to {br} {billingName} Wallet', { br: <br />, billingName: name })}</div>
					<div className='subtitle'>
						{t('Your personal crypto wallet for everyday payments and work with cryptocurrency.')}
					</div>

					<div className='WelcomePage-block-btn'>
						<Button onClick={() => navigate(routes.signUp)}>{t('Sign up')}</Button>

						{/* <Button
							onClick={() =>
								HelperService.verifyEmailPhone({
									verificationEmail: true,
									verificationPhone: true,
									successNotifficationText: 'Success',
									successRedirectRoute: routes.signIn,
								})
							}
						>
							{t('Sign up')}
						</Button> */}
						<Button styleType='white' onClick={() => navigate(routes.signIn)}>
							{t('Sign in')}
						</Button>
					</div>
				</div>
			</div>

			{/* <ButtonBar>
				<div className='WelcomePage-ButtonBar'>
					<AdaptiveButton
						onClick={() => console.log('clickIcon v v clickIcon')}
						icon='CHECKMARK_CIRCLE_FILL'
					></AdaptiveButton>

					<ContextualMenu icon='CHECKMARK_CIRCLE_FILL'>Children</ContextualMenu>

					<ButtonToMenu openComponent={openComponent} closeComponent={closeComponent} showShadow={true} />
				</div>
			</ButtonBar> */}
		</div>
	);
};

export default WelcomePage;
